import React from "react";
import "../assets/css/footware.css";
import { NavLink } from "react-router-dom";

export default function Footware() {
  return (
    <footer className="footerPro">

      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-box">
          <h2>✈️ Trip Word</h2>
          <p>
            Your Journey, Our Responsibility — We create unforgettable travel
            experiences across India & worldwide.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-box">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <NavLink to="/about">
              <li>About</li>

            </NavLink>

            <NavLink to="/services">
              <li>Services</li>

            </NavLink>
            <NavLink className="navitem" to="/gallery">
              <li className="list-style-type-none">Gallery</li>

            </NavLink>


            <NavLink to="/contact">
              <li>Contact</li>

            </NavLink>
          </ul>
        </div>

        {/* POLICY */}
        <div className="footer-box">
          <h3>Legal</h3>
          <ul>
            <li>Privacy Policy</li>
            <li>Terms & Conditions</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-box">
          <h3>Contact</h3>
          <p>📞 +91 9699581519</p>
          <p>📧 info@tripword.com</p>
          <p>🌐 tripword.in</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        © 2026 Trip Word. All Rights Reserved.
      </div>

    </footer>
  );
}